module.exports = __webpack_public_path__ + "static/media/discover.4a80290d.svg";